import React from 'react';
import Button from '../../Components/UI/Button';
import classes from './ModalSkeleton.module.css';
import { Modal } from 'react-bootstrap';

const ModalSkeleton = ({
  children,
  show,
  title,
  subTitle = '',
  setShow,
  onConfirm,
  isApiCall,
  confirmText,
  gapBetweenHeadAndBody = '20px',
  borderRadius = '20px',
  width = '100%',
  padding,
  position = 'centered',
  isCancel = true
}) => {
  const isCentered = position === 'centered';
  return (
    <>
      <style jsx>{`
        .modal-content {
          overflow: visible !important;
          width: 100%;
          max-width: ${width};
          margin: auto;
          border-radius: ${borderRadius};
          overflow: hidden;
          padding: ${padding};
          gap: ${gapBetweenHeadAndBody};
        }
        .modal-header {
          flex-direction: row;
          border-bottom: none;
          padding: 0px;
        }
        .modal-body {
          width: 100%;
          padding: 0px;
        }
      `}</style>
      <Modal show={show} onHide={setShow} centered={isCentered}>
        <Modal.Header>
          <div className={[classes.headerDiv].join(' ')}>
            <h2 className={[classes.headingText].join(' ')}>{title}</h2>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.content}>{children}</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalSkeleton;
